import { FC } from 'react';
import { useLocation, useParams } from 'react-router';

import NewEquipment from './equipment';
import NewGeneral from './general';
import NewReefer from './reefer';
import NewTrucking from './trucking';

import ErrorDialog from 'components/organization/dialog/error-dialog';
import { useAuth } from 'contexts';
import { Role } from 'types';
import { SaveTemplateDialog } from '../details';
import { useNewBooking } from './new-booking';
import './new-booking.scss';

const NewBookingForm: FC = () => {
  const { pathname } = useLocation();
  const { templateName } = useParams();
  const { userProfile } = useAuth();

  const { formRef, handleReset, handleSaveAs, handleSubmit, booking, setBooking, dialogProps } = useNewBooking();

  return (
    <form className="page" id="new-booking" onReset={handleReset} onSubmit={handleSubmit} ref={formRef}>
      <div className="page-header">
        <h1>{pathname.includes('bookings') ? 'NEW BOOKING' : 'TEMPLATE'}</h1>
        <div className="d-flex g-3 flex-row-reverse">
          <button className="btn-primary" type="submit" data-cy='submit-booking-button'>
            {pathname.includes('templates') ? 'SAVE TEMPLATE' : 'SUBMIT'}
          </button>
          {/* templates are denied to GATE_BOOKING by the API */}
          {!templateName && userProfile.role !== Role.GATE_BOOKING && (
            <button className="btn-outline" type="button" onClick={handleSaveAs}>
              SAVE AS TEMPLATE
            </button>
          )}
          <button className="btn-outline" type="reset">
            CANCEL
          </button>
        </div>
      </div>
      <div className="page-content flex-fill">
        <NewGeneral />
        <NewEquipment />
        <NewReefer />
        <div className="card-primary">
          <div className="card-header px-3">
            <h4>TRUCKING DETAILS</h4>
          </div>
          <div className="card-body">
            <NewTrucking booking={booking} setBooking={setBooking} />
          </div>
        </div>
      </div>
      <SaveTemplateDialog booking={booking} {...dialogProps} />
      <ErrorDialog />
    </form>
  );
};

export default NewBookingForm;
